// extracted by mini-css-extract-plugin
export default {"new-password-container":"forgetPasswordForm_new-password-container__lkdgK","new-password-container-subtitle":"forgetPasswordForm_new-password-container-subtitle__riAz8"};